import React, { Component } from 'react';
import ReactExport from "react-export-excel-xlsx-fix";
import { ImportExport } from "@mui/icons-material";
import moment from "moment";
import Global from "../../customlib/Global";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


class ExportLeadsTiktok extends Component {

    getleadsReportData = () => {
        return this.props.data;
    }

    state = {  }
    render() { 
        return (
            <ExcelFile element={<button className="btn btn-primary"><ImportExport />Export ke Excel</button>}>
                <ExcelSheet data={this.getleadsReportData} name="Leads Tiktok">
                    <ExcelColumn label="Campaign" value="campaign"/>
                    <ExcelColumn label="Leads" value="leadsCount"/>
                    <ExcelColumn label="Closing" value="closing"/>
                    <ExcelColumn label="Closing Rate" value="closingRate"/>
                    <ExcelColumn label="Revenue" value="orderValue"/>
                    {/* <ExcelColumn label="Tanggal"
                                  value={(col) => Global.formatDateTimeToStrDateTime24(col.created_at)}/> */}
                    
                </ExcelSheet>
            </ExcelFile>
        );
    }
}
 
export default ExportLeadsTiktok;